// extracted by mini-css-extract-plugin
export default {"wrapper":"AddHorseBtn_wrapper__tVypH","btn":"AddHorseBtn_btn__+q+O7","plusIcon":"AddHorseBtn_plusIcon__-tD-y"};